import React from 'react';
import PropTypes from 'prop-types';
import Breakpoint from './breakpoint';

const DesktopBreakpoint = props => (
  <Breakpoint name="desktop">
    {props.children}
  </Breakpoint>
);

DesktopBreakpoint.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DesktopBreakpoint;



// WEBPACK FOOTER //
// ./src/app/components/responsiveUtilities/desktop.jsx